var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerCycleEndGradePlace } from './AbfragerCycleEndGradePlace';
import { AbfragerCycleEndImageReward } from './AbfragerCycleEndImageReward';
import { runtime } from '../../../../classes/runtime/Runtime';
let AbfragerCycleEndAnswerPart = class AbfragerCycleEndAnswerPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        if (!runtime.availablePackages.Defer)
            return null;
        const { GoogleAd } = runtime.availablePackages.Defer.components;
        return (React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', flexDirection: 'row', alignItems: 'stretch' } },
            React.createElement("div", { style: { flex: '1 1 50%', display: 'flex', flexDirection: 'column' } },
                React.createElement(AbfragerCycleEndGradePlace, { app: question.context.app }),
                React.createElement(AbfragerCycleEndImageReward, { question: question })),
            React.createElement("div", { style: {
                    flex: '1 1 50%',
                    display: 'flex',
                    alignItems: 'stretch',
                    paddingRight: 10,
                    marginTop: 'auto',
                    marginBottom: 'auto'
                } },
                React.createElement(GoogleAd, { app: question.context.app, slotId: 1586846089, style: { width: '100%', minWidth: 300, maxWidth: 400, height: '100%', minHeight: 400, maxHeight: 600 } }))));
    }
};
AbfragerCycleEndAnswerPart = __decorate([
    observer
], AbfragerCycleEndAnswerPart);
export { AbfragerCycleEndAnswerPart };
